export const DocsLoader = Object({
    web: {
        _visible: true,
        _title: 'Download Requisiti Tecnici',
        _link: 'mcwp3.it.infrontfinance.com/mcwp3/documentazione/Requisiti_Tecnici_Market_Connect_Web_3.pdf'
    },
    client: {
        _visible: true,
        _title: 'Scarica ora MC Client TCP 443',
        _link: 'it.infrontfinance.com/allegati/client/Market_Connect_Remote_Installer.exe'
    },
    none:{
        _visible: false,
        _title:'none',
        _link:'none'
    }
})